// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  font-size: 10px;
  margin: 0px;
  padding: 0px;
  align-items: flex-end;
}
.terms-link {
  margin-bottom: 10px;
}

.copyright-text {
  color: black;
  font:bold;
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX","sourcesContent":[".terms-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 10px;\n  font-size: 10px;\n  margin: 0px;\n  padding: 0px;\n  align-items: flex-end;\n}\n.terms-link {\n  margin-bottom: 10px;\n}\n\n.copyright-text {\n  color: black;\n  font:bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
